/**
 * Sonnerie synthétisée via Web Audio API — aucun fichier audio à fournir ni
 * à héberger, ça marche à l'identique partout. Cadence proche d'une sonnerie
 * téléphonique classique : deux bips brefs, silence, répétition.
 */

const FREQUENCE_HZ = 440;
const DUREE_BIP_S = 0.18;
const INTERVALLE_MS = 500;

export interface Sonnerie {
  demarrer: () => void;
  arreter: () => void;
}

export function creerSonnerie(): Sonnerie {
  let contexte: AudioContext | null = null;
  let minuteur: ReturnType<typeof setInterval> | null = null;

  function bip(): void {
    if (!contexte) return;
    const oscillateur = contexte.createOscillator();
    const gain = contexte.createGain();
    oscillateur.frequency.value = FREQUENCE_HZ;
    oscillateur.connect(gain);
    gain.connect(contexte.destination);

    const maintenant = contexte.currentTime;
    gain.gain.setValueAtTime(0.0001, maintenant);
    gain.gain.exponentialRampToValueAtTime(0.2, maintenant + 0.03);
    gain.gain.exponentialRampToValueAtTime(0.0001, maintenant + DUREE_BIP_S);

    oscillateur.start(maintenant);
    oscillateur.stop(maintenant + DUREE_BIP_S + 0.02);
  }

  return {
    demarrer(): void {
      if (minuteur) return;
      try {
        contexte ??= new AudioContext();
        void contexte.resume();
        bip();
        minuteur = setInterval(bip, INTERVALLE_MS);
      } catch {
        // Web Audio indisponible (ancien navigateur, politique restrictive) :
        // la modale de sonnerie reste visible, c'est le principal.
      }
    },
    arreter(): void {
      if (minuteur) clearInterval(minuteur);
      minuteur = null;
    },
  };
}
